function MainContent() {
  return (
    <div className="image-container">
      <img
        src="https://yihyoni.github.io/nff_product/nff_bg.svg"
        alt="배경"
        className="bg-image"
      />
    </div>
  );
}

export default MainContent;
